import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Vol2 from "../pages/vol2/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vol2",
    element: <Vol2 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
